import { render, staticRenderFns } from "./MoAntGreenButton.vue?vue&type=template&id=782ac544&scoped=true&"
import script from "./MoAntGreenButton.vue?vue&type=script&lang=js&"
export * from "./MoAntGreenButton.vue?vue&type=script&lang=js&"
import style0 from "./MoAntGreenButton.vue?vue&type=style&index=0&id=782ac544&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782ac544",
  null
  
)

export default component.exports